export const GET_COMBO_LOAI_TAI_SAN = "GET_COMBO_LOAI_TAI_SAN";
export const GET_COMBO_LOAI_TAI_SAN_SUCCESS = "GET_COMBO_LOAI_TAI_SAN_SUCCESS";
export const GET_COMBO_LOAI_TAI_SAN_FAILURE = "GET_COMBO_LOAI_TAI_SAN_FAILURE";

export const POST_LOAI_TAI_SAN_TM = "POST_LOAI_TAI_SAN_TM";
export const POST_LOAI_TAI_SAN_TM_SUCCESS = "POST_LOAI_TAI_SAN_TM_SUCCESS";
export const POST_LOAI_TAI_SAN_TM_FAILURE = "POST_LOAI_TAI_SAN_TM_FAILURE";

export const SHOW_MODAL_LOAI_TAI_SAN = "SHOW_MODAL_LOAI_TAI_SAN";
